import React, { useState } from "react";
import { connect } from "react-redux";
import VirtualizedSelect from "react-virtualized-select";
import PropTypes from "prop-types";

// Importing CSS for react-virtualized-select
import "react-virtualized/styles.css";
import "react-virtualized-select/styles.css";
import {  Row, Col, Form,} from "react-bootstrap";
import MiniLoader from "./../../../../utilityComponents/MiniLoader";
import Message from "./../../../../utilityComponents/Message";
import {
  updateTagNameAndScenarioGroupIds,
  updateScenarioGroupIdAndBenchNames,
  updateScenarioGroupNameAndBenchNames,
  updateScenarioGroupNameWithIdAndBenchNames,
  updateBenchNameAndRunIds,
  updateRunIdAndScenarioIds,
  updateScenarioUUIDAndDescription,
  resetFilterFormData,
} from "./../../../../actions/closeLoop/kpiDashboard/dashboardActions";
import {
  resetLaneManagementKPIGraph,
  resetLongitudinalMotionKPIGraph,
  resetSafeDrivingKPIGraph,
  resetEgoVelocityKPIGraph,
  resetL1LateralAccelerationKPIGraph,
  resetL1LateralJerkKPIGraph,
  resetL1LongitudinalDecelerationKPIGraph,
  resetL1LongitudinalAccelerationKPIGraph,
  resetL1LongitudinalJerkKPIGraph,
  resetL1LongitudinalVelocityDropKPIGraph,
  resetL0CollisionCheckKPIGraph,
  resetL0LateralSafeDistanceKPIGraph,
  resetL0LongitudinalSafeDistanceKPIGraph,
  resetL0OffRoadCheckKPIGraph,
  resetL0LaneMarkingCheckKPIGraph,
  resetL0IndicatorCheckingKPIGraph,
  resetL0SpeedLimitCheckKPIGraph,
  resetL0FalseIndicatorCheckKPIGraph,
  resetRSSLongitudinalSafeCheckKPIGraph,
  resetRSSLateralLeftSafeCheckKPIGraph,
  resetRSSLateralRightSafeCheckKPIGraph,
} from "./../../../../actions/closeLoop/kpiDashboard/dashboardGraphs/dashboardGraphActions";
import {
  resetDownloadXOSCFileStatus,
  resetDownloadKPIFiles,
} from "./../../../../actions/closeLoop/kpiDashboard/download/downloadReportsActions";

function KPIForm(props) {
  const [tagName, setTagName] = useState("");
//   const [groupId, setGroupId] = useState("");
  const [bench, setBench] = useState("");
  const [testRun, setTestRun] = useState("");
  const [sceneId, setSceneId] = useState("");
  const [groupNameWithId, setGroupNameWithId] = useState("");
//   const [groupName, setGroupName] = useState("");
//   const [isGroupNameAvailable, setGroupNameAvailable] = useState(false);

  const clearInputFields = (field) => {
    if (field === "tagName") {
    //   setGroupId("");
      setGroupNameWithId("");
      setBench("");
      setTestRun("");
      setSceneId("");
    } else if (field === "scenarioGroupId") {
      setBench("");
      setTestRun("");
      setSceneId("");
    } else if (field === "scenarioGroupName") {
      setBench("");
      setTestRun("");
      setSceneId("");
    } else if (field === "scenarioGroupNameWithId") {
      setBench("");
      setTestRun("");
      setSceneId("");
    } else if (field === "benchName") {
      setTestRun("");
      setSceneId("");
    } else if (field === "runId") {
      setSceneId("");
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
  };

  const resetGraphData = () => {
    // Resetting TJA KPI Data;
    props.resetLaneManagementKPI();
    props.resetLongitudinalMotionKPI();
    props.resetSafeDrivingKPI();
    props.resetEgoVelocityKPI();

    // Resetting Level One KPI Data
    props.resetL1LateralAccelerationKPI();
    props.resetL1LateralJerkKPI();
    props.resetL1LongitudinalDecelerationKPI();
    props.resetL1LongitudinalAccelerationKPI();
    props.resetL1LongitudinalJerkKPI();
    props.resetL1LongitudinalVelocityDropKPI();

    // Resetting Level Two KPI Data
    props.resetL0CollisionCheckKPI();
    props.resetL0LateralSafeDistanceKPI();
    props.resetL0LongitudinalSafeDistanceKPI();
    props.resetL0OffRoadCheckKPI();
    props.resetL0LaneMarkingCheckKPI();
    props.resetL0IndicatorCheckingKPI();
    props.resetL0SpeedLimitCheckKPI();
    props.resetL0FalseIndicatorCheckKPI();

    // Resetting RSS KPI Data
    props.resetRSSLongitudinalSafeCheckKPI();
    props.resetRSSLateralLeftSafeCheckKPI();
    props.resetRSSLateralRightSafeCheckKPI();

    // Resetting XOSC Download File Status;
    props.resetDownloadXOSCStatus();

    // Resetting Download KPI Files Status;
    props.resetDownloadKPIStatus();
  };

  console.log(props);
  return (
    <>
      {props.scenarioInfoLoading ? (
        <MiniLoader />
      ) : props.scenarioInfoError ? (
        <Message variant={"danger"}>{props.scenarioInfoError}</Message>
      ) : (
        <Form onSubmit={onSubmit}>
          <Row>
            <Col md={12} xl={12}>
              <Row>
                <Col md={6} xl={6}>
                  <Form.Label style={{ color: "#FFFFFF" }}>
                    Software Version
                  </Form.Label>
                </Col>
                <Col md={6} xl={6}>
                  <VirtualizedSelect
                    required
                    placeholder="Software Version"
                    options={props.tagNames}
                    onChange={(tag) => {
                      if (tag && tag.label) {
                        setTagName(tag);
                        const payload = {
                          tag_name: tag.label,
                          cad_topology_job_uuid: [
                            ...new Set(
                              props.tagRecords
                                .filter(
                                  (item) => item["tag_name"] === tag.label
                                )
                                .map((item) => item["cad_topology_uuid"])
                            ),
                          ],
                        };
                        props.updateTagName(payload);
                        clearInputFields("tagName");
                        props.resetFormData();
                        resetGraphData();
                      }
                    }}
                    value={tagName}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={6} xl={6}>
                  <Form.Label style={{ color: "#FFFFFF" }}>
                    Scenario Group Name - ID
                  </Form.Label>
                </Col>
                <Col md={6} xl={6}>
                  <VirtualizedSelect
                    required
                    placeholder="Scenario Group Name - Id"
                    options={props.scenarioGroupNamesWithId}
                    onChange={(id) => {
                      if (id && id.label) {
                        setGroupNameWithId(id);
                        props.updateScenarioGroupNameWithId(id.label);
                        clearInputFields("scenarioGroupNameWithId");
                      }
                    }}
                    value={groupNameWithId}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={6} xl={6}>
                  <Form.Label style={{ color: "#FFFFFF" }}>
                    Bench Name
                  </Form.Label>
                </Col>
                <Col md={6} xl={6}>
                  <VirtualizedSelect
                    required
                    placeholder="Bench Name"
                    options={props.benchNames}
                    onChange={(name) => {
                      if (name && name.label) {
                        setBench(name);
                        props.updateBenchName(name.label);
                        clearInputFields("benchName");
                      }
                    }}
                    value={bench}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={6} xl={6}>
                  <Form.Label style={{ color: "#FFFFFF" }}>Run ID</Form.Label>
                </Col>
                <Col md={6} xl={6}>
                  <VirtualizedSelect
                    required
                    placeholder="Test Run Id"
                    options={props.testRunIds}
                    onChange={(runId) => {
                      if (runId && runId.label) {
                        setTestRun(runId);
                        const info = {
                          tag_name: props.tag,
                          test_run_id: runId.label,
                        };
                        props.updateRunId(runId.label, info);
                        clearInputFields("runId");
                      }
                    }}
                    value={testRun}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={6} xl={6}>
                  <Form.Label style={{ color: "#FFFFFF" }}>
                    Scenario Name
                  </Form.Label>
                </Col>
                <Col>
                  <VirtualizedSelect
                    required
                    placeholder="Scenario name"
                    options={props.scenarioIds}
                    onChange={(sceneUuid) => {
                      if (sceneUuid && sceneUuid.label) {
                        setSceneId(sceneUuid);
                        props.updateScenarioId(sceneUuid.label);
                        resetGraphData();
                      }
                    }}
                    value={sceneId}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Form>
      )}
    </>
  );
}

const mapStateToProps = (state) => ({
  tagNames: state.dashboardFilterData.info.tagNames,
  tag: state.dashboardFilterData.info.selectData.tagName,
  tagRecords: state.dashboardFilterData.info.tagRecords,
  scenarioGroupIds: state.dashboardFilterData.info.scenarioGroupIds,
  scenarioGroupNames: state.dashboardFilterData.info.scenarioGroupNames,
  scenarioGroupNamesWithId:
    state.dashboardFilterData.info.scenarioGroupNamesWithId,
  groupId: state.dashboardFilterData.info.selectData.scenarioGroupId,
  benchNames: state.dashboardFilterData.info.benchNames,
  bench: state.dashboardFilterData.info.selectData.benchName,
  testRunIds: state.dashboardFilterData.info.runIds,
  testRunId: state.dashboardFilterData.info.selectData.runId,
  scenarioInfoLoading: state.dashboardFilterData.info.scenarioInfo.loading,
  scenarioInfoError: state.dashboardFilterData.info.scenarioInfo.error,
  scenarioIds: state.dashboardFilterData.info.scenarioIds,
});

const mapDispatchToProps = (dispatch) => ({
  updateTagName: (payload) =>
    dispatch(updateTagNameAndScenarioGroupIds(payload)),
  updateScenarioGroupId: (scenarioGroupId) =>
    dispatch(updateScenarioGroupIdAndBenchNames(scenarioGroupId)),
  updateScenarioGroupName: (scenarioGroupName) =>
    dispatch(updateScenarioGroupNameAndBenchNames(scenarioGroupName)),
  updateScenarioGroupNameWithId: (scenarioGroupNameWithId) =>
    dispatch(
      updateScenarioGroupNameWithIdAndBenchNames(scenarioGroupNameWithId)
    ),
  updateBenchName: (benchName) => dispatch(updateBenchNameAndRunIds(benchName)),
  updateRunId: (runId, info) =>
    dispatch(updateRunIdAndScenarioIds(runId, info)),
  updateScenarioId: (scenarioId) =>
    dispatch(updateScenarioUUIDAndDescription(scenarioId)),
  resetFormData: () => dispatch(resetFilterFormData()),
  resetLaneManagementKPI: () => dispatch(resetLaneManagementKPIGraph()),
  resetLongitudinalMotionKPI: () => dispatch(resetLongitudinalMotionKPIGraph()),
  resetSafeDrivingKPI: () => dispatch(resetSafeDrivingKPIGraph()),
  resetEgoVelocityKPI: () => dispatch(resetEgoVelocityKPIGraph()),
  resetL1LateralAccelerationKPI: () =>
    dispatch(resetL1LateralAccelerationKPIGraph()),
  resetL1LateralJerkKPI: () => dispatch(resetL1LateralJerkKPIGraph()),
  resetL1LongitudinalDecelerationKPI: () =>
    dispatch(resetL1LongitudinalDecelerationKPIGraph()),
  resetL1LongitudinalAccelerationKPI: () =>
    dispatch(resetL1LongitudinalAccelerationKPIGraph()),
  resetL1LongitudinalJerkKPI: () => dispatch(resetL1LongitudinalJerkKPIGraph()),
  resetL1LongitudinalVelocityDropKPI: () =>
    dispatch(resetL1LongitudinalVelocityDropKPIGraph()),
  resetL0CollisionCheckKPI: () => dispatch(resetL0CollisionCheckKPIGraph()),
  resetL0LateralSafeDistanceKPI: () =>
    dispatch(resetL0LateralSafeDistanceKPIGraph()),
  resetL0LongitudinalSafeDistanceKPI: () =>
    dispatch(resetL0LongitudinalSafeDistanceKPIGraph()),
  resetL0OffRoadCheckKPI: () => dispatch(resetL0OffRoadCheckKPIGraph()),
  resetL0LaneMarkingCheckKPI: () => dispatch(resetL0LaneMarkingCheckKPIGraph()),
  resetL0IndicatorCheckingKPI: () =>
    dispatch(resetL0IndicatorCheckingKPIGraph()),
  resetL0SpeedLimitCheckKPI: () => dispatch(resetL0SpeedLimitCheckKPIGraph()),
  resetL0FalseIndicatorCheckKPI: () =>
    dispatch(resetL0FalseIndicatorCheckKPIGraph()),
  resetRSSLongitudinalSafeCheckKPI: () =>
    dispatch(resetRSSLongitudinalSafeCheckKPIGraph()),
  resetRSSLateralLeftSafeCheckKPI: () =>
    dispatch(resetRSSLateralLeftSafeCheckKPIGraph()),
  resetRSSLateralRightSafeCheckKPI: () =>
    dispatch(resetRSSLateralRightSafeCheckKPIGraph()),
  resetDownloadXOSCStatus: () => dispatch(resetDownloadXOSCFileStatus()),
  resetDownloadKPIStatus: () => dispatch(resetDownloadKPIFiles()),
});

// Prop types for KPIForm Component.
KPIForm.propTypes = {
  resetLaneManagementKPI: PropTypes.func,
  resetLongitudinalMotionKPI: PropTypes.func,
  resetSafeDrivingKPI: PropTypes.func,
  resetEgoVelocityKPI: PropTypes.func,
  resetL1LateralAccelerationKPI: PropTypes.func,
  resetL1LateralJerkKPI: PropTypes.func,
  resetL1LongitudinalDecelerationKPI: PropTypes.func,
  resetL1LongitudinalAccelerationKPI: PropTypes.func,
  resetL1LongitudinalJerkKPI: PropTypes.func,
  resetL1LongitudinalVelocityDropKPI: PropTypes.func,
  resetL0CollisionCheckKPI: PropTypes.func,
  resetL0LateralSafeDistanceKPI: PropTypes.func,
  resetL0LongitudinalSafeDistanceKPI: PropTypes.func,
  resetL0OffRoadCheckKPI: PropTypes.func,
  resetL0LaneMarkingCheckKPI: PropTypes.func,
  resetL0IndicatorCheckingKPI: PropTypes.func,
  resetL0SpeedLimitCheckKPI: PropTypes.func,
  resetL0FalseIndicatorCheckKPI: PropTypes.func,
  resetRSSLongitudinalSafeCheckKPI: PropTypes.func,
  resetRSSLateralLeftSafeCheckKPI: PropTypes.func,
  resetRSSLateralRightSafeCheckKPI: PropTypes.func,
  resetDownloadXOSCStatus: PropTypes.func,
  resetDownloadKPIStatus: PropTypes.func,

  tag: PropTypes.string,
  scenarioInfoLoading: PropTypes.bool,
  scenarioInfoError: PropTypes.string,

  tagNames: PropTypes.array,
  tagRecords: PropTypes.array,
  scenarioGroupNamesWithId: PropTypes.array,
  benchNames: PropTypes.array,
  testRunIds: PropTypes.array,
  scenarioIds: PropTypes.array,

  updateRunId: PropTypes.func,
  updateTagName: PropTypes.func,
  resetFormData: PropTypes.func,
  updateScenarioGroupNameWithId: PropTypes.func,
  updateBenchName: PropTypes.func,
  updateScenarioId: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(KPIForm);
